<div *ngIf="isLoading" class="se-loader"></div>
<!-- Main Grid -->
<div class=" p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">

      <button class="se-button btnAddMessage cursorPointerHand" (click)="OnAddMessage()">
        {{ labels.addBroadcastMessage | translate }}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div class="rectangle-grid">
      <p-table #dt [columns]="messageCols" [value]="broadcastMessages" [paginator]="isPagination" [rows]="10" responsiveLayout="stack" [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.field === 'isActive'" [ngStyle]="{'width': col.width, 'display': col.display }">

              {{col.header | translate}}
              <p-sortIcon [field]="col.field" *ngIf="col.field !== 'isActive'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" class="box-shadow-none">
              {{ labels.dgTblHeaderActions | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr class="rowHeight">
            <td *ngFor="let col of columns" class="overflow-control">
              <span *ngIf="col.field =='from' || col.field =='to'">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm'}}
              </span>
              <span *ngIf="col.field =='message'" title="{{rowData[col.field]}}">
                {{rowData[col.field]}}
              </span>

            </td>
            <td>
              <label class="se-block-action switch">
                <input type="checkbox" [(ngModel)]="rowData.isActive" class="alarmrule-block-check" (click)="EditMessageStatus(rowData, $event)"
                       (keypress)="EditMessageStatus(rowData, $event)"
                       (keydown)="EditMessageStatus(rowData, $event)"
                       (keyup)="EditMessageStatus(rowData, $event)" />
                <span class="slider round"></span>
              </label>

              <img class="icon-action editIcon" (click)="OnEditMessage(rowData)" (keydown)="OnEditMessage(rowData)" height="21" width="21"  alt="edit" src="assets/edit.svg" />
              <img class="icon-action iconDeleteMessage" (click)="OnDeleteMessage(rowData)" (keydown)="OnDeleteMessage(rowData)" height="29" width="29" alt="delete" src="assets/delete.svg" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="warn"></p-toast>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="onRejectToast()" [baseZIndex]="5000"></p-toast>


<div class="se-dialog" *ngIf="showAddEditDialog">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ addEditModalHeader | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form">
        <div class="form-ele col-md-12">
          <label for="pcalstartDate" class="se-label col-md-3 mt-2">  {{labels.selectStartDate | translate}}</label>

          <p-calendar name="pcalstartDate" ngDefaultControl [inputStyle]="{'width':'250px','height':'35px','color':'#434343','border-top-style':'none','line-height':'85px','border-radius':'0px','border-left-style':'none','border-right-style':'none','border-color':'#7d7d7d','font-family':'Nunito','font-size':'16px','border-width':'initial'}"
                      [(ngModel)]="fromDate" dateFormat="dd-MM-yy" [showIcon]="true" (onSelect)="ValidateForm()"
                      appendTo="body" readonlyInput="true"  [showTime]="true" dataType="string" utc="true"
                      placeholder="{{labels.fromdate|translate}}">

          </p-calendar>

        </div>
        <div class="form-ele col-md-12">
          <label for="pcalendDate" class="se-label col-md-3 mt-2">  {{labels.selectEndDate | translate}}</label>

          <p-calendar name="pcalendDate" ngDefaultControl [inputStyle]="{'width':'250px','height':'35px','color':'#434343','border-top-style':'none','line-height':'85px','border-radius':'0px','border-left-style':'none','border-right-style':'none','border-color':'#7d7d7d','font-family':'Nunito','font-size':'16px','border-width':'initial'}"
                      [(ngModel)]="toDate" dateFormat="dd-MM-yy" [showIcon]="true" dataType="string" utc="true"
                      appendTo="body" readonlyInput="true"  [showTime]="true"
                      (onSelect)="ValidateForm()" placeholder="{{labels.todate|translate}}">

          </p-calendar>
        </div>
        <div class="form-ele col-md-12">
          <label for="desc" class="se-label col-md-3 mt-2">{{ labels.addBoradcastmessage | translate }}</label>

          <textarea id="desc" name="desc" maxlength="4000" class="se-form-control col-md-6 txta-fix-height no-resize" placeholder="Type your broadcast message" [(ngModel)]="txtmessage" (keyup)="ValidateForm()"></textarea>
        </div>
      </div>
    </div>
    <div class="se-label  noteSection">
      {{labels.dateInUTC}}
    </div>

    <div class="se-dialog-footer">
      <button class="se-button btnCancel" (click)="OnCancelAddEdit()">{{ labels.cancel | translate }}</button>
      <button class="se-button button-primary btnSave" [disabled]="formInvalid" [ngClass]="{ 'disabled-cls': formInvalid }" (click)="OnSaveOrEditMessage()">{{labels.saveAndApp | translate}}</button>
    </div>
  </div>
</div>
<div class="se-dialog" *ngIf="showDeleteModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title">{{ labels.DeleteBroadcastMessage }}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{ messages.deleteDevice | translate }}
    </div>
    <div class="se-dialog-footer">
      <button class="se-button btnNo" (click)="OnMessageDeleteReject()">{{ labels.no | translate}}</button>
      <button class="se-button btnYes " (click)="OnMessageDeleteConfirm()">{{ labels.yes | translate}}</button>
    </div>
  </div>
</div>
